import React from "react";
import { Link } from "gatsby";
import { Case_Arrow } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Caseusa = () => {
  return (
      <section className="case_flex">
        <div className="flex_item" style={{ backgroundColor: "#6acec3" }}>
          <div className="case_txt">
            <div className="case_logo">
              <StaticImage
                  src="../../images/services-usa/healthcare-software/case-logo-1.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={198}
                  height={70}
              />
            </div>
            <div className="case_title">
              <h3>Easy solution to opt for a healthy lifestyle.</h3>
              <Link
                  to="/case-studies/stop-vaping"
                  className="case-usabtn"
                  aria-label="TekRevol Contact"
              >
                View Case Study {Case_Arrow}
              </Link>
            </div>
          </div>
          <div className="case_figure">
            <StaticImage
                src="../../images/services-usa/healthcare-software/case-study-1.webp"
                alt="Reck’N mobile app"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={675}
                height={460}
            />
          </div>
        </div>
        <div className="flex_item" style={{ backgroundColor: "#50cfff" }}>
          <div className="case_txt">
            <div className="case_logo">
              <StaticImage
                  src="../../images/services-usa/healthcare-software/case-logo-2.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={146}
                  height={70}
              />
            </div>
            <div className="case_title">
              <h3>Transforming health record management systems.</h3>
              <Link
                  to="/case-studies/milocare"
                  className="case-usabtn"
                  aria-label="TekRevol Contact"
              >
                View Case Study {Case_Arrow}
              </Link>
            </div>
          </div>
          <div className="case_figure">
            <StaticImage
                src="../../images/services-usa/healthcare-software/case-study-2.webp"
                alt="Selah"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={405}
                height={475}
            />
          </div>
        </div>
        <div className="flex_item" style={{ backgroundColor: "#4145A9" }}>
          <div className="case_txt">
            <div className="case_logo">
              <StaticImage
                  src="../../images/services-usa/healthcare-software/case-logo-3.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={85}
                  height={70}
              />
            </div>
            <div className="case_title">
              <h3>Revolutionizing the healthcare system.</h3>
              <Link
                  to="/case-studies/nurse-practitioners"
                  className="case-usabtn"
                  aria-label="TekRevol Contact"
              >
                View Case Study {Case_Arrow}
              </Link>
            </div>
          </div>
          <div className="case_figure">
            <StaticImage
                src="../../images/services-usa/healthcare-software/case-study-3.webp"
                alt="Onsite Social "
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={405}
                height={475}
            />
          </div>
        </div>
      </section>
  );
};

export default Caseusa;
